<template>
  <v-container>
    <v-row
        no-gutters
        v-for="(item, index) in items"
        :key="item.key"
        justify="center"
        align="center"
    >
      <location-menu-section
          :limit="100"
          :title="item.title"
          :value="item.items"
          v-on:action="val => handleAction(val, index, item)"
          v-on:change="data => updateSection(data, index)"
      />
    </v-row>

    <v-container>
      <v-row
          no-gutters
          justify="center"
          align="center"
      >
        <v-col cols="12" md="8" xs="12" v-if="this.items.length < this.limit">
          <location-menu-add-section-modal :action="addSection" clearOnSubmit/>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import LocationMenuSection from '@/views/Locations/Components/LocationMenuSection'
import LocationMenuAddSectionModal from '@/views/Locations/Modals/LocationMenuAddSectionModal'
export default {
  name: "LocationMenuSections",
  components: {
    LocationMenuSection,
    LocationMenuAddSectionModal
  },
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
  },
  data: () => ({
    items: [],
    nextKey: 0
  }),
  methods: {
    updateSection: function(data, index) {
      this.items[index].title = data.title
      this.items[index].items = data.items
      this.change()
    },
    addSection: function(data) {
      this.addOne(null, { title: data.title, items: data.item.title ? [data.item] : [] })
    },
    handleAction: function(value, index, item) {
      switch (value) {
        case 'FIRST':
          this.moveItem(item, 0, index)
          break
        case 'LAST':
          this.moveItem(item, this.items.length - 1, index)
          break
        case 'UP':
          if (index === 0) break
          this.moveItem(item, index - 1, index)
          break
        case 'DOWN':
          this.moveItem(item, index + 1, index)
          break
        case 'ADD_UP':
          this.addOne(index === 0 ? 0 : index - 1)
          break
        case 'ADD_DOWN':
          this.addOne(index + 1)
          break
        case 'DELETE':
          this.removeOne(null, index)
          break
      }
    },
    change: function() {
      this.$emit('change', this.items)
    },
    addOne: function(index, { title, items } = { title: '', items: [] }) {
      this.nextKey++
      if (this.items.length < this.limit) {
        if (typeof index === 'number') {
          this.items.splice(index, 0, { title, items, key: this.nextKey })
        } else {
          this.items.push({ title, items, key: this.nextKey })
        }
      }
      this.change()
    },
    removeOne: function(event, index) {
      if (this.items.length > 0) {
        this.items.splice(index, 1)
        this.change()
      }
    },
    moveItem: function(item, newIndex, oldIndex) {
      this.items.splice(oldIndex, 1)
      this.items.splice(newIndex, 0, item)
      this.change()
    }
  },
  created() {
    if (this.value && Array.isArray(this.value)) {
      this.items = this.value.map((i, index) => ({ key: index, ...i}))
      this.nextKey = this.items.length + 1
    }
  },
  watch: {
    value: function (value) {
      this.items = value.map((i, index) => ({ key: i.id ? i.id : index, ...i}))
      this.nextKey = this.items.length + 1
    }
  }
}
</script>

<style scoped>
</style>